import { useTranslation } from 'react-i18next';
import IconLoop from './icon_loop.svg';
import s from './index.module.scss';

export const EmptyContent = () => {
  const { t } = useTranslation('reports');
  return (
    <div className={s.wrapper}>
      <div className={s.icon}>
        <img src={IconLoop} alt="empty" width={24} height={24} />
      </div>
      <div className="f-article-accent">{t('empty_content.no_data')}</div>
      <div
        className="f-small-regular"
        style={{ color: 'var(--Black-100, #414141)' }}
      >
        {t('empty_content.reports_appear')}
      </div>
    </div>
  );
};
